var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#B32F4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0537 27.9315H21.9871C25.2564 27.9315 27.9063 25.3791 27.9063 22.2315V8.06854H15.9768C15.1918 8.06854 14.439 8.36884 13.8839 8.90336C13.3288 9.43789 13.017 10.1629 13.017 10.9188L13.013 13.6813",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09375 18.7534H13.0129M16.6208 18.7534H24.1364M16.6208 22.4292H24.1364M10.0536 13.6813H13.0129V25.0812C13.0126 25.837 12.7008 26.5617 12.1459 27.0961C11.591 27.6306 10.8384 27.931 10.0536 27.9314C9.26871 27.9312 8.51603 27.6308 7.96101 27.0963C7.40599 26.5618 7.09405 25.837 7.09375 25.0812V16.531C7.0942 15.7752 7.4062 15.0506 7.96121 14.5162C8.51621 13.9819 9.26881 13.6816 10.0536 13.6813ZM16.6208 12.2123H19.9047V15.3745H16.6208V12.2123Z",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.03968ac68cecc50b6c337edb53be052c.svg";
export { ForwardRef as ReactComponent };